import { Graphics } from 'pixi.js-legacy';
import { intersects } from '../helpers';
export class SelectRectangle extends Graphics {
    draw(pos, width, height, actual) {
        this.clear();
        this.lineStyle(2, 0xbfbfbf, 1);
        this.beginFill(0xbfbfbf, 0.3);
        this.drawRect(0, 0, width, height);
        this.endFill();
        this.x = pos.x;
        this.y = pos.y;
        this.actualPos = actual;
    }
    contains(obj) {
        const thisRect = {
            x: this.actualPos.x,
            y: this.actualPos.y,
            width: this.width,
            height: this.height,
        };
        const objRect = {
            x: obj.position.x,
            y: obj.position.y,
            width: obj.width,
            height: obj.height,
        };
        return intersects(thisRect, objRect);
    }
}
